
/**
 * Import axios globally and register the CSRF Token as a common header so that
 * all outgoing HTTP requests automatically have it attached.
 */
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

const funnel = document.head.querySelector('meta[name="f"]');
if (funnel) {
	window.axios.defaults.headers.common['FROM-FUNNEL'] = funnel.content;
}
